import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { ClockAlert, CirclePlus } from 'lucide-react';

import Page from '@/components/layout/Page';
import Loader from '@/components/common/Loader';
import {
  Empty,
  EmptyIcon,
  EmptyTitle,
  EmptyDescription
} from '@/components/ui/empty';
import HeaderWithBack from '@/components/common/HeaderWithBack';
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  CardDescription
} from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { getLocalDateFromDate } from '@/helpers/dateHelpers';
import { useCoachActivities } from '@/data/coachActivity';
import { useCoachSelf } from '@/data/coach';
import { useAvailabilitySelf } from '@/data/availability';
import AddAvailabilityForm from './components/availabilityDayPage/add/AddAvailabilityForm';
import AvailabilityCard from './components/availabilityDayPage/AvailabilityCard';

const AvailabilityDay = () => {
  const [isAdding, setIsAdding] = useState(false);
  const params = useParams();
  const availabilities = useAvailabilitySelf(params.date);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Availability</CardTitle>
        <CardDescription>{getLocalDateFromDate(params.date)}</CardDescription>
      </CardHeader>
      <CardContent>
        {availabilities.data.length === 0 && !isAdding && (
          <Empty>
            <EmptyIcon>
              <ClockAlert />
            </EmptyIcon>
            <EmptyTitle>No Availabilities Found</EmptyTitle>
            <EmptyDescription>Try adding an availability</EmptyDescription>
          </Empty>
        )}
        <div className="space-y-4">
          {availabilities.data.map((availability) => (
            <AvailabilityCard
              key={availability.id}
              availability={availability}
            />
          ))}

          {isAdding && (
            <Card className="py-4">
              <CardContent>
                <AddAvailabilityForm setIsAdding={setIsAdding} />
              </CardContent>
            </Card>
          )}
        </div>
        {!isAdding && (
          <div className="flex justify-center py-6">
            <Button
              type="button"
              variant="ghost"
              onClick={() => setIsAdding(true)}
            >
              <CirclePlus />
              &nbsp;Add Availability
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

const AvailabilityDayPage = () => {
  const coachActivities = useCoachActivities();
  const coach = useCoachSelf();
  const params = useParams();
  const availabilities = useAvailabilitySelf(params.date);

  if (
    (coachActivities.isLoading && !coachActivities.data) ||
    (coach.isLoading && !coach.data) ||
    (availabilities.isLoading && !availabilities.data)
  ) {
    return (
      <Page>
        <HeaderWithBack to="/availability" title="Calendar" />
        <div className="flex justify-center items-center h-[calc(100vh-180px)]">
          <Loader />
        </div>
      </Page>
    );
  }

  return (
    <Page>
      <HeaderWithBack to="/availability" title="Calendar" />
      <div className="pb-20">
        <AvailabilityDay />
      </div>
    </Page>
  );
};

export default AvailabilityDayPage;
